import {create} from 'zustand';
import {sortByKey} from 'presentation/utils';
import {UseOpenExamDrawerStoreProps} from './types';

export const useOpenExamDrawerStore = create<UseOpenExamDrawerStoreProps>((set, get) => ({
	dataExam: undefined,
	setDataExam: data => set({dataExam: data}),
	resetDataExam: () => set({dataExam: undefined}),
	isCompleteResult: () => {
		const {dataExam} = get();
		if (!dataExam) {
			return false;
		}
		return dataExam.list.every(exam => !!exam.dtLaudo && exam.dtLaudo !== null);
	},
	getExamByDownload: () => {
		const {dataExam} = get();
		if (!dataExam) {
			return undefined;
		}
		const dataExamFiltered = dataExam.list.filter(
			exam => !!exam.dtLaudo && exam.dtLaudo !== null,
		);
		const dataExamSorted = sortByKey(dataExamFiltered, 'dtLaudo');
		return dataExamSorted[0];
	},
}));
